const getters = {
  getCertificationVersions: (state) => state.certificationVersions,
  getCertificationHistory: (state) => state.certificationHistory,
  getCertificationHistoryCertificationId: (state) =>
    state.certificationHistoryCertificationId,
  getCertificationHistoryCertification: (state) =>
    state.certificationHistoryCertification,
  getCertificationVersion: (state) => state.certificationVersion,
  getCertificationExam: (state) => state.certificationExam,
  getLaunchConfiguration: (state) => state.launchConfiguration,
}

export default getters
